// extracted by mini-css-extract-plugin
export var divider = "_38-0";
export var dividerText = "_38-2";
export var dividerVertical = "_38-1";